<template>
    <content-layout>

        <div class="file-filter-container">
            <div class="row column">
                <ul class="filter clearfix">
                    <li><router-link to="/inbox/comments" active-class="active">Komentāri</router-link></li>
                    <li><router-link to="/inbox/messages" active-class="active">Ziņas</router-link></li>
                </ul>
            </div>
        </div>

        <keep-alive>
            <router-view></router-view>
        </keep-alive>

    </content-layout>
</template>

<script>
    import ContentLayout from '../layouts/ContentLayout'
    import SvgIcon from '../components/SvgIcon.vue'
    import avatarIcon from '../../icons/icon-avatar.svg-sprite'

    export default {

        data() {
            return {
                avatarIcon
            }
        },

        components: {ContentLayout, SvgIcon}
    }
</script>

<style lang="scss">
    .page-content {
        margin: 2rem 0;

        > .column {
            padding: 0;
        }
    }

    .file-filter-container {
        background-color: white;
    }


</style>


// WEBPACK FOOTER //
// resources/assets/js/views/Inbox.vue